<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Icon, Text, ButtonV2 } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let marginTop = '0';
	export let marginTopMd = '0';
	export let marginTopSm = '0';
	export let title = $format('h1_devices_filter_no_results', {
		default: 'No such devices found.',
	});
	export let message = $format('text_devices_filter_check_criteria_again', {
		default: 'Try another search and check the applied filters.',
	});
	export let icon = 'fa-light fa-magnifying-glass';
	export let buttonText = '';
	export let onClick: () => void = null;
</script>

<div class="d-flex flex-direction-column align-items-center justify-content-center">
	<Icon {icon} class="mt-{marginTop} mt-md-{marginTopMd} mb-m mt-sm-{marginTopSm}" size="l" />

	<Text styleType="h1" class="mb-s text-center">
		{title}
	</Text>
	<Text class="text-color-muted text-center mb-m">
		{message}
	</Text>
	{#if buttonText}
		{#if $showNewLayout}
			<ButtonV2
				variant="primary"
				on:click={() => {
					onClick();
				}}
			>
				{buttonText}
			</ButtonV2>
		{:else}
			<Button
				on:click={() => {
					onClick();
				}}
			>
				{buttonText}
			</Button>
		{/if}
	{/if}
</div>
